/* eslint-disable @typescript-eslint/no-explicit-any */
const ShowAddressLabel = ({
  address,
  showAddressLabel,
}: {
  address: any
  showAddressLabel: boolean
}) => {
  return showAddressLabel
    ? `${address?.description || ''} - ${address?.address?.other || ''}`
    : address?.address?.other || ''
}

export default ShowAddressLabel
